<!--
 * @Author: YuanYuan
 * @Date: 2024-02-06 10:46:37
 * @LastEditTime: 2025-09-08 16:05:31
 * @description: 并发数
-->
<template>
  <div>
    <el-row :gutter="16">
      <el-col v-bind="$const['Common/SearchCol']">
        <QuerySelectSearch
          v-model="searchForm.ports"
          :data="portOptions"
          v-loading="portLoading"
          :label="$t('common.port')"
          label-key="port"
          value-key="port" />
      </el-col>
      <el-col v-bind="$const['Common/SearchCol']">
        <el-button @click="queryHandler" type="primary">{{$t('common.query')}}</el-button>
      </el-col>
    </el-row>
    <div class="flex-row-between-center mt-12 mb-16">
      <div class="summary-block">
        <span class="summary-block_name">{{$t('usage.maxConcurValue')}}</span>
        <div>
          <span class="summary-block_value">{{numeralFormatter(peakValue)}}</span>
          <span class="summary-block_time">[{{peakTime||'-'}}]</span>
        </div>
      </div>
    </div>
    <LineChart :options="lineChartData" v-loading="loading" />
  </div>
</template>

<script setup>
import { ref, getCurrentInstance, reactive, watch, toRefs } from 'vue'
import LineChart from '@/components/echarts/Line.vue'
import { beijingTime2TerminalTime } from '@/utils/time'
import { assign } from 'lodash-es'
import { numeralFormatter } from '@/utils/base'

const $vm = getCurrentInstance().proxy

const props = defineProps({
  topParams: {
    type: Object,
    default: () => ({
      packageId: '',
      beijingStartTime: '',
      beijingEndTime: ''
    })
  }
})
const { topParams } = toRefs(props)

const portOptions = ref([])
const portLoading = ref(false)
const searchForm = reactive({
  ports: []
})
let lineChartData = reactive({
  xAxis: {
    data: []
  },
  series: []
})
const peakTime = ref('')
const peakValue = ref(0)
const loading = ref(false)

const getParams = () => {
  const params = {
    package_id: topParams.value.packageId,
    begin_time: topParams.value.beijingStartTime,
    end_time: topParams.value.beijingEndTime,
    contentNum_select: searchForm.ports.join(',')
  }
  return params
}

const queryHandler = () => {
  loading.value = true
  $vm.$api['usage/concurrenciesQuery'](getParams()).then(res => {
    if (res?.code === 200 && res?.data) {
      peakTime.value = beijingTime2TerminalTime(res.data?.peakStat?.peakTime)
      peakValue.value = res.data?.peakStat?.peakValue || 0
      if (res.data?.connections?.length) {
        lineChartData = assign(lineChartData, {
          xAxis: {
            data: res.data.connections.map(n => beijingTime2TerminalTime(n.time))
          },
          series: [
            { data: res.data.connections.map(n => n.value), name: $vm.$t('usage.concurrencies'), color: '#47cbff' }
          ]
        })
      }
    }
  }).finally(() => (loading.value = false))
}

const queryPortOptions = () => {
  if (topParams.value.packageId) {
    portLoading.value = true
    $vm.$api['usage/concurrentPorts']({ packageId: topParams.value.packageId }).then(res => {
      if (res?.code === 200 && res?.data?.length) {
        portOptions.value = res.data.map(n => ({ port: n }))
        if (searchForm.ports.length) {
          // 保留之前选择的且仍在新数据中存在的端口
          searchForm.ports = searchForm.ports.filter(n => res.data.includes(n))
        } else {
          searchForm.ports = res.data
        }
        queryHandler()
      } else {
        portOptions.value = []
        searchForm.ports = []
        queryHandler()
      }
    }).finally(() => (portLoading.value = false))
  }
}

watch(() => topParams.value, () => {
  queryPortOptions()
}, { deep: true, immediate: true })
</script>

<style lang="scss" scoped>
@import './summaryStyle.scss';
</style>
